"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualEntry_other = void 0;
var manualEntry_other = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, hasReturnVal = utils.hasReturnVal, use = utils.use;
    describe('Manual entry - other', function () {
        it('08:30 PM >> [ 1 > < 2 ] >> 02:30 PM', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .type('1')
                .then(hasReturnVal("13:30"))
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(use.rightArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .then(use.leftArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml(1).hrs12))
                .type('2')
                .should('have.value', '02:30 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .then(hasReturnVal("14:30"));
        });
        it('08:30 PM >> [ > 1 > < 2 ] >> 08:02 PM', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.rightArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .type('1')
                .then(hasReturnVal("20:01"))
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(use.rightArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                .then(use.leftArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml(1).minutes))
                .type('2')
                .should('have.value', '08:02 PM')
                .then(a11yHasExpectedHtml('<p>2.</p>'))
                .then(hasReturnVal("20:02"));
        });
        it('08:30 PM >> [ > > AM ] >> 08:30 AM', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.rightArrow)
                .then(use.rightArrow)
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                .type('AM')
                .should('have.value', '08:30 AM')
                .then(a11yHasExpectedHtml('<p>AM.</p>'))
                .then(hasReturnVal("08:30"));
        });
        it('08:30 PM >> [ > > AM PM ] >> 08:30 AM', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .type('{rightarrow}{rightarrow}ampm')
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml('<p>PM.</p>'))
                .then(hasReturnVal("20:30"));
        });
        it('08:30 PM >> [ 1 blur focus 1 ] >> 01:30 PM', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .type('1')
                .should('have.value', '01:30 PM')
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(hasReturnVal("13:30"))
                .blur()
                .focus()
                .wait(10)
                .type('1')
                .should('have.value', '01:30 PM')
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(hasReturnVal("13:30"))
                .type('1')
                .should('have.value', '11:30 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .then(hasReturnVal("23:30"));
        });
    });
};
exports.manualEntry_other = manualEntry_other;
